import { useEffect, useState } from "react";
import Button from "../../../../../../common/components/xepp/button/Button";
import styles from "./WorkflowCard.module.scss";
import { useLazyGetWorkflowByIdQuery } from "../../../../../../service/customersupport-service";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setServiceRequestType } from "../../../../../../stores/slices/service-type-slice";
import { ApplicationRoutes } from "../../../../../../routes";
import { getErrorMessage } from "../../../../../../utils/error-handler";
import { hideLoader, showLoader } from "../../../../../../stores/slices/loader-slice";
import { WorkflowDefinition } from "../../../../../../model/workflows/workflow-definition";
import { setWorkflow } from "../../../../../../stores/slices/workflow-slice";

interface Props {
	workflow: WorkflowDefinition;
	index: number;
}

const WorkflowCard = (props: Props) => {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const [dialogOpen, setDialogOpen] = useState(false);

	const [getWorkflowById, { isLoading: isGettingServiceRequest }] = useLazyGetWorkflowByIdQuery();

	useEffect(() => {
		if (!dialogOpen) return;
		const handleClick = (e: any) => {
			if (!e.target.closest(`.${CSS.escape(styles.dialog)}`) && !e.target.closest(`.${CSS.escape(styles.actionContainer)}`)) {
				setDialogOpen(false);
			}
		};
		document.addEventListener("click", handleClick);
		return () => document.removeEventListener("click", handleClick);
	}, [dialogOpen]);

	const onEditClick = () => {
		dispatch(showLoader());
		const fetchServiceRequest = async () => {
			try {
				const st = await getWorkflowById(props.workflow.id).unwrap();
				dispatch(setWorkflow(st));
				navigator(`${props.workflow.id}/${ApplicationRoutes.CUSTOM_STEPS}`);
			} catch (err: any) {
				getErrorMessage(err.data);
			}

			dispatch(hideLoader());
		};
		fetchServiceRequest();
	};

	return (
		<>
			<div key={props.index} className={styles.workflowContainer}>
				{/* <div className={styles.imageContainer}>

                </div> */}
				<div className={styles.nameContainer}>{props.workflow.name}</div>
				<div className={styles.descriptionContainer}>
					<span>{props.workflow.description}</span>
				</div>
				{/* EKEDC: Workflow management disabled - statical SR definitions submitted through UI
				<div className={styles.actionContainer}>
					<Button
						text="Manage"
						variant="outline"
						onClick={() => {
							setDialogOpen(!dialogOpen);
						}}
					/>
					{dialogOpen && (
						<>
							<div className={styles.dialog}>
								<div
									className={styles.dialogOption}
									onClick={() => {
										navigator(`${ApplicationRoutes.NEW}/${props.workflow.id}`);
									}}
								>
									Edit Basic Info
								</div>
								<div className={styles.dialogOption} onClick={onEditClick}>
									Edit Steps
								</div>
							</div>
						</>
					)}
				</div>
				*/}
			</div>
		</>
	);
};

export default WorkflowCard;
